






import Vue from 'vue'
import Things from '@/components/Card/Things/Index.vue'

export default Vue.extend({
  components: {
    Things
  }
})
